import * as React from "react";
import OrganizationManager from "@/components/organization/OrganizationManager";

interface OrganizationTabProps {
  clientId: number;
}

export default function OrganizationTab({ clientId }: OrganizationTabProps) {
  return <OrganizationManager ownerType="client" ownerId={clientId} />;
}
